import { MinzeElement, Reactive, Attrs } from 'minze'

export interface LvcSearchTwoIcon {
  iconSize?: number
  dataSize?: number
}

export class LvcSearchTwoIcon extends MinzeElement {
  attrs: Attrs = [['data-size', 24]]
  reactive: Reactive = [['iconSize', this.dataSize || 24]]

  static observedAttributes = ['data-size']

  onAttributeChange = (name: string) => {
    if (name === 'data-size') {
      this.iconSize = this.dataSize || 24
    }
  }

  html = () => `
<svg 
width="${this.iconSize}" 
height="${this.iconSize}"
viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.05782 4.51341C4.15436 5.39142 3.44453 6.45683 2.98255 7.64181C2.32999 9.31563 2.20293 11.1486 2.6183 12.8964C3.5954 16.5491 7.18417 18.9416 10.8369 19.1151C12.6507 19.2052 14.4459 18.7133 15.9605 17.7113C17.4751 16.7092 18.6299 15.2494 19.2563 13.5448C19.8539 11.8314 19.9033 9.97449 19.3977 8.23176C18.892 6.48904 17.8564 4.94693 16.4346 3.81946C14.7764 2.59094 12.7554 1.95157 10.6923 2.00286C8.62925 2.05415 6.64245 2.79315 5.04735 4.10254M6.88276 6.26685C5.92393 8.6411 5.12033 11.3076 6.53575 13.6818C7.09456 14.6354 7.92147 15.4035 8.91355 15.8906C9.90563 16.3777 11.0191 16.5623 12.1152 16.4213C13.1931 16.2579 14.2033 15.7945 15.0301 15.0839C15.8569 14.3733 16.4671 13.4444 16.7907 12.4034C17.105 11.3475 17.1293 10.2264 16.861 9.15794C16.5926 8.08944 16.0416 7.11288 15.2657 6.33077C13.622 4.65053 10.8003 3.81954 8.74563 5.26236M17.0129 16.8895L21.2957 21.5193" stroke="#1E007D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`

  css = () => `
    :host {    
      height: ${this.iconSize}px;
    }
  `
}
